import $ from 'jquery';
import { Modal } from 'antd';
import { getNodeId } from './cy-core';
import AWS_CONFIG, { ICON_FILE, UPLOAD_SIZE_LIMIT } from '../../../constants/constants';
import { setReloadIcon } from '../../../redux/authSlice';

const AWS = require('aws-sdk/dist/aws-sdk-react-native');

// callback is saveNodeInfo function
export const uploadFiles = (userId, callback) => {
  const files = document.getElementById('photoupload')?.files;
  if (!files?.length) {
    // debug-console.log('uploadS3Photo: No file to upload. Skip!');
    callback();
    return;
  }
  if (!userId) {
    Modal.warn({
      content: 'Bạn cần đăng nhập để có thể Upload ảnh.',
      centered: true,
      closable: true,
    });
    return;
  }
  const file = files[0];
  // var fileSize = file.size;
  // // debug-console.log('uploadS3Photo: file size =' + Math.round(file.size / 10000) / 100 + ' MB');
  if (file.size > UPLOAD_SIZE_LIMIT) {
    alert('Error : File size is bigger than 3MB : ' + Math.round(file.size / 10000) / 100 + ' MB');
    return;
  }
  const fileName = file.name;
  const nodeId = getNodeId();

  const photoKey = `${AWS_CONFIG.s3.imgFolder}/${userId}/${nodeId}/${fileName}`;
  
  const uploadedImgUrl = `${AWS_CONFIG.s3.staticHostUrl}/${
    AWS_CONFIG.s3.imgFolder
  }/${encodeURIComponent(userId)}/${nodeId}/${encodeURIComponent(fileName)}`;

  // Use S3 ManagedUpload class as it supports multipart uploads
  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: AWS_CONFIG.s3.bucketName,
      Key: photoKey,
      Body: file,
    },
  });

  const promise = upload.promise();

  promise.then(
    (data) => {
      // Set new Image URL to form:
      $('#imgUrl').val(uploadedImgUrl); // $.val(data.Location);

      // debug-console.log('uploadS3Photo: Successfully uploaded photo: S3 photo key=', photoKey);
      // // debug-console.log('uploadS3Photo: Cloudfront Url=', imgUrl);
      // // debug-console.log(data);
      const saveResult = true;
      callback(saveResult);
    },
    (err) => alert('There was an error uploading your photo: ', err.message),
  );
};

export const uploadData = (fileData, userId, callback) => {
  console.info('upload Data: for '+userId, fileData);
  if (!userId) {
    Modal.warn({
      content: 'Bạn cần đăng nhập để có thể Upload ảnh.',
      centered: true,
      closable: true,
    });
    return;
  }
  // var fileSize = file.size;
  // // debug-console.log('uploadS3Photo: file size =' + Math.round(file.size / 10000) / 100 + ' MB');

  const photoKey = `${AWS_CONFIG.s3.imgFolder}/${userId}/${ICON_FILE}`;
  
  // const uploadedImgUrl = `${AWS_CONFIG.s3.staticHostUrl}/${
  //   AWS_CONFIG.s3.imgFolder
  // }/${encodeURIComponent(userId)}/${ICON_FILE}`;

  // Use S3 ManagedUpload class as it supports multipart uploads
  const upload = new AWS.S3.ManagedUpload({
    params: {
      Bucket: AWS_CONFIG.s3.bucketName,
      Key: photoKey,
      Body: fileData,
    },
  });

  const promise = upload.promise();

  promise.then(
    (data) => {
      // debug-console.log('uploadS3Photo: Successfully uploaded photo: S3 photo key=', photoKey);
      // // debug-console.log('uploadS3Photo: Cloudfront Url=', imgUrl);
      // // debug-console.log(data);
      const saveResult = true;
      callback(saveResult);
    },
    (err) => {
      console.log(err);
      alert('There was an error uploading your photo: ', err.message);
    },
  );
};
// function listAlbums() {
//   // debug-console.log('Listing folders:');
//   s3.listObjects({ Delimiter: '/' }, function (err, data) {
//     if (err) {
//       return alert('There was an error listing your albums: ' + err.message);
//     } else {
//       var albums = data.CommonPrefixes.map(function (commonPrefix) {
//         var prefix = commonPrefix.Prefix;
//         var albumName = decodeURIComponent(prefix.replace('/', ''));
//         return albumName;
//       });
//       // debug-console.log(albums);
//       if (albums.indexOf(userId) == -1) {
//         // debug-console.log('S3 folder ' + userId + ' not exist');
//         //createAlbum(userId);
//       }
//     }
//   });
// }

// function createAlbum(albumName) {
//   // debug-console.log('Create S3 folder : ' + albumName);
//   albumName = albumName.trim();
//   if (!albumName) {
//     return alert('Album names must contain at least one non-space character.');
//   }
//   if (albumName.indexOf('/') !== -1) {
//     return alert('Album names cannot contain slashes.');
//   }
//   var albumKey = encodeURIComponent(albumName);
//   s3.headObject({ Key: albumKey }, function (err, data) {
//     if (!err) {
//       return alert('Album already exists.');
//     }
//     if (err.code !== 'NotFound') {
//       return alert('There was an error creating your album: ' + err.message);
//     }
//     s3.putObject({ Key: albumKey }, function (err, data) {
//       if (err) {
//         return alert('There was an error creating your album: ' + err.message);
//       }
//       // debug-console.log('Successfully created album ' + albumName);
//       //viewAlbum(albumName);
//     });
//   });
// }

// function getHtml(template) {
//   return template.join('\n');
// }
